import React from "react";
import { useAuth } from "../../../usercontext";
import GlobalAdditionalInfo from "../../pages/common/globaladdinfo";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
import PageNotes from '../../pages/common/pagenotesnew'

export default function StudentAdditionalInfo() {
	const { profile } = useAuth()
	const slug = profile.id
	const isStudent12 = profile?.role === 'Student12'
	const isStudent = profile?.role === 'Student'
	return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu="AdditionalInfo" />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu="AdditionalInfo" />}
			<PageNotes type={'Student'} studentId={slug} />
			<div className="col-12">
				<div className="settings-widget">
					<GlobalAdditionalInfo slug={slug} />
				</div>
			</div>
		</>
	)
}
